const ITEMS = [
  "ALAMEDA PRIVATE GYMS",
  "1-ON-1 SKILL LAB",
  "D1 RECRUITING ACCESS",
  "EXPLOSIVE AGILITY",
  "90%+ FT MECHANICS",
  "BOYS & GIRLS • AGES 11 TO D1",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-court-surface/50 py-4 select-none">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-display font-bold uppercase tracking-widest text-lg text-zinc-500">
                <span className="px-6">{item}</span>
                <span className="w-2 h-2 rounded-full bg-court-amber inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
